import React, { useState } from "react";
import contact from "../assets/contact.jpg";
import { link } from "../assets/icons";
import { Notify } from "../utils/helpfunctions";
import { contact_Us } from "../API/axios";

function ContactUs() {
  const [formData, setFormData] = useState({});
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading("submit");

    const copy = { ...formData, contact: formData?.contact ?? "" };

    const form = new FormData();
    form.append("data", JSON.stringify(copy));
    form.append("file", file);

    await contact_Us(form)
      .then((res) => {
        Notify("Email has been sent Successfully", "success");
      })
      .catch((err) => {
        Notify("Email not sent, please try again", "error");
      });

    setLoading(null);
  };

  const handleFileChange = (e) => {
    if (e.target.files[0]) {
      if (e.target.files[0].size > 5 * 1024 * 1024) {
        Notify("File size must be less than or equal to 5 MB", "error");
        e.target.value = null;
        return;
      }
      setFile(e.target.files[0]);
      e.target.value = null;
    }
  };

  return (
    <div className="w-full h-fit flex ">
      <form
        onSubmit={handleSubmit}
        className="w-full md:w-1/2 lg:w-2/5 h-fit p-4 smd:p-6 md:p-8 gap-4 md:gap-8 flex flex-col items-center text-teal"
      >
        <h1 className="w-fit text-lg md:text-xl lg:text-3xl font-bold font-mont mt-8">
          Get In Touch With Us
        </h1>

        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4 p-4 md:p-8">
          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium">
              Name <span className="text-red-700">*</span>
            </label>
            <input
              type="text"
              name="name"
              required
              placeholder="Enter name"
              value={formData.name || ""}
              onChange={(e) =>
                setFormData({ ...formData, name: e.target.value })
              }
              className="w-full placeholder:text-gray-400 pb-1.5 text-black outline-none border-transparent border-b-2 focus:border-transparent focus:border-b-purp p-0 focus:ring-0 border-b-teal"
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium">
              Email <span className="text-red-700">*</span>
            </label>
            <input
              type="email"
              name="email"
              required
              placeholder="Enter email"
              value={formData.email || ""}
              onChange={(e) =>
                setFormData({ ...formData, email: e.target.value })
              }
              className="w-full placeholder:text-gray-400 pb-1.5 text-black outline-none border-transparent border-b-2 focus:border-transparent focus:border-b-purp p-0 focus:ring-0 border-b-teal"
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium">Contact</label>
            <input
              type="number"
              name="phone"
              placeholder="Enter contact number"
              value={formData.contact || ""}
              onChange={(e) =>
                setFormData({ ...formData, contact: e.target.value })
              }
              className="w-full placeholder:text-gray-400 pb-1.5 text-black outline-none border-transparent border-b-2 focus:border-transparent focus:border-b-purp p-0 focus:ring-0 border-b-teal"
            />
          </div>

          <div className="flex flex-col gap-1">
            <label className="text-sm font-medium">
              Company <span className="text-red-700">*</span>
            </label>
            <input
              type="text"
              name="company"
              required
              placeholder="Enter company name"
              value={formData.company || ""}
              onChange={(e) =>
                setFormData({ ...formData, company: e.target.value })
              }
              className="w-full placeholder:text-gray-400 pb-1.5 text-black outline-none border-transparent border-b-2 focus:border-transparent focus:border-b-purp p-0 focus:ring-0 border-b-teal"
            />
          </div>

          <div className="flex flex-col gap-2 col-span-1 md:col-span-2 mt-4">
            <label className="text-sm font-medium">
              Describe Your Requirements <span className="text-red-700">*</span>
            </label>
            <textarea
              type="text"
              required
              placeholder="Describe your requirements"
              value={formData.description || ""}
              onChange={(e) =>
                setFormData({ ...formData, description: e.target.value })
              }
              className="w-full placeholder:text-gray-400 text-black h-[100px] pb-1.5 outline-none border-2 border-teal focus:border-purp rounded-md p-2 focus:ring-0 resize-none"
            />
          </div>

          <div className="flex flex-col gap-1 col-span-1 md:col-span-2 mt-4">
            <label className="text-sm font-medium flex flex-wrap items-center gap-1">
              Attach Document
              <span className="text-gray-400 text-xs whitespace-nowrap">
                (Max 5MB, only text,pdf, zip or rar)
              </span>
            </label>
            <label
              htmlFor="supportFile"
              className="w-full py-3 cursor-pointer border-b-2 border-b-teal flex items-center gap-4"
            >
              <span className="w-5">{link}</span>
              <h1 className="font-medium text-gray-700">Choose File</h1>
              <p className="text-gray-400">
                {file ? file?.name : "No file chosen"}
              </p>
            </label>

            <input
              type="file"
              id="supportFile"
              accept=".txt, .pdf, .zip, .rar"
              onChange={handleFileChange}
              className="sr-only w-full pb-1.5 text-black outline-none border-transparent border-b-2 focus:border-transparent focus:border-b-purp p-0 focus:ring-0 border-b-teal"
            />
          </div>
        </div>

        <div className="w-full flex justify-end px-4 smd:px-6 md:px-8 md:-mt-4">
          {loading === "submit" ? (
            <div className="w-4 h-4 border-2 border-teal border-t-transparent rounded-full animate-spin"></div>
          ) : (
            <button
              type="submit"
              className="w-fit px-3 py-1.5 font-medium bg-teal rounded-md text-white"
            >
              Submit
            </button>
          )}
        </div>
      </form>

      <div
        style={{ backgroundImage: `url(${contact})` }}
        className="hidden md:inline w-1/2 lg:w-3/5 h-[700px] bg-cover rounded-bl-[300px] shadow-xl"
      ></div>
    </div>
  );
}

export default ContactUs;
